import React, { FC, useEffect, useState } from "react";
import { Menu } from "antd";
import type { MenuProps } from "antd";
import { MenuData, icons, getMenuNames } from "../config/menu";
import { Link, useLocation } from "react-router-dom";
import { useLoginData } from "./AuthProvier";



type MenuLayoutProps = {
    onSelectMenus?: Function
}


const buildItems = (menu: any): NonNullable<MenuProps["items"]>[number] => {
    const Icon: any = icons[`${menu.perms}`];
    const MenuIcon: any = Icon ? <Icon /> : null;
    const children: Array<any> = menu.children;
    if (children?.length) {
        return {
            key: menu.path,
            icon: MenuIcon,
            label: menu.name,
            children: children.map((child: any) => buildItems(child)),
        };
    }
    return {
        key: menu.path,
        icon: MenuIcon,
        label: <Link to={menu.path}>{menu.name}</Link>,
    };
};

const hiddenMenuPerms = new Set(["coupon"]);

const filterMenus = (menus: MenuData[]): MenuData[] => {
    return menus
        .filter((menu: any) => !hiddenMenuPerms.has(`${menu.perms}`))
        .map((menu: any) => ({
            ...menu,
            children: menu.children ? filterMenus(menu.children) : menu.children,
        }));
};


const MenuLayout: FC<MenuLayoutProps> = ({ onSelectMenus}) => {

    const user = useLoginData();

    const menus: MenuData[] = filterMenus(user.menus);

    const location = useLocation();

    const [openKeys, setOpenKeys] = useState<Array<string>>([]);

    const getPathArr = (paths:string)=>{


        if(paths == "/"){
            return ["/"];
        }

        const pathArrs = [];
        const arrs = paths.split("/");
        let str = "";
        for(let i =0; i < arrs.length;i++){

            if(arrs[i]){
                str+=`/${arrs[i]}`;
                pathArrs.push(`${str}`);
            }
        
        }

        return pathArrs;

    }

    const selectedKeys = getPathArr(location.pathname);

    useEffect(() => {
        const defaultOpenKeys = getPathArr(location.pathname);
        setOpenKeys(defaultOpenKeys);

        if(onSelectMenus){
            onSelectMenus(getMenuNames(defaultOpenKeys,menus));
        }

    }, [location.pathname]);




    const items = menus.map((it) => buildItems(it));

    return (
        <Menu
            theme="light"
            mode="inline"
            items={items}
            openKeys={openKeys}
            onOpenChange={setOpenKeys}
            selectedKeys={selectedKeys}
        />
    )
}

export default MenuLayout;
